import { createRouter, createWebHistory } from 'vue-router';
import { utmTagsLib, handleChunkLoadError } from 'freedom-shared';
import type { App } from 'vue';

import { useFilterIntentStore } from '@/features/search-offers-filter';

import { sentryModel } from '@/shared/model';

import { routes } from './routes';

export const withRouter = (app: App) => {
  const base = '/avia/'; // Path under which the app is deployed on a server

  const router = createRouter({
    history: createWebHistory(base),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (to.name === 'OffersResults') {
        // A filter applied from the offer-details night-transfer modal
        // ("Применить фильтр") returns here via router.back(). vue-router calls
        // scrollBehavior inside its own nextTick — AFTER OfferFilters.onActivated
        // has already consumed the filter intent — so we read a dedicated
        // one-shot flag (not `pending`, which is gone by now) to force the
        // freshly filtered list to the top instead of restoring the
        // pre-navigation offset. (On iOS the body is the scroll container and
        // window.scrollTo is a no-op, so ResultsPage.scrollToTop covers that.)
        if (useFilterIntentStore().consumeScrollToTop()) {
          return { top: 0 };
        }
        if (savedPosition) {
          return savedPosition;
        }
      }
      return { top: 0 };
    },
  });

  router.beforeEach((to, from, next) => {
    const locationWithUtmTags = utmTagsLib.getLocationWithUtmTags(to, from);

    if (locationWithUtmTags) {
      next(locationWithUtmTags);
    } else {
      next();
    }
  });

  handleChunkLoadError({
    router,
    sentryModel,
    errorPrefix: sentryModel.errorPrefix.AVIA,
    storagePrefix: 'free-avia',
  });

  app.use(router);

  return router;
};
